import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { selectProductsSorting } from 'providers/menuMaker/Products/selectors';
import { getProducts } from 'providers/menuMaker/Products/actions';

import { sortingOrderTypes, sortingPropertyTypes } from 'utils/products';

export function useSortingProducts() {
  const dispatch = useDispatch();
  const {
    property,
    filterByText,
    filterByCategories,
    filterByTypeSoldProduct,
    filterByBrands,
    withoutBrands,
    withoutCategories,
    direction,
    orderBy,
    isSearchFilter,
  } = useSelector(selectProductsSorting);

  function handleSetSortingByFilters(filtersArgs) {
    const filters = filtersArgs;

    if (filters?.filterByText === null || filters?.filterByText === undefined) {
      delete filters.filterByText;
    }
    if (filters?.filterByTypeSoldProduct === null || filters?.filterByTypeSoldProduct === undefined) {
      delete filters.filterByTypeSoldProduct;
    }
    if (filters?.filterByCategories?.length === 0 && !filters?.withoutCategories) {
      delete filters.withoutCategories;
    }
    if (filters?.filterByBrands?.length === 0 && !filters?.withoutBrands) {
      delete filters.withoutBrands;
    }

    dispatch(getProducts({ ...filters, isSorting: true }));
    dispatch(getProducts.sorting({ ...filters, isSearchFilter: true }));
  }

  function handleSetSortingByProperty({
    property: propertyArg,
    filterByText: filterByTextArg = filterByText,
    direction: directionArg,
  }) {
    dispatch(
      getProducts.sorting({
        property: propertyArg,
        direction: directionArg,
        filterByText: filterByTextArg,
      }),
    );
  }

  function handleResetSorting() {
    dispatch(getProducts.resetSorting());
  }

  return {
    sortingProperty: property,
    sortingFilterByText: filterByText,
    sortingDirection: direction,
    setSortingByFilters: useCallback(handleSetSortingByFilters, [dispatch]),
    setSortingByProperty: useCallback(handleSetSortingByProperty, [dispatch, filterByText]),
    sortingOrderTypes,
    sortingPropertyTypes,
    sortingFilterByCategories: filterByCategories,
    resetSorting: useCallback(handleResetSorting, [dispatch]),
    filtersSorting: {
      filterByCategories,
      [filterByText.length && 'filterByText']: filterByText,
      filterByTypeSoldProduct,
      filterByBrands,
      withoutBrands,
      withoutCategories,
      isSearchFilter,
      orderBy,
    },
  };
}

export default useSortingProducts;
